export const iconFontAwesomeSportsFitnessSpa = (
	<i className="fa-solid fa-spa"></i>
);
